import React, { useState, useEffect } from "react";
import axios from "axios";
import { Navbar } from "../componentes/navbar";
import { CardComponent } from "../componentes/cardComponent";
import { Form, Space, Row, Col, Button, Switch, Select, Popconfirm } from "antd";
import { InputCustom } from "../componentes/inputComponent";
import { TablaCompleta } from "../tablas/tabla_simple";
import { FaRegEdit, FaRegTrashAlt, FaUserPlus, FaUserMinus } from "react-icons/fa";
import { manejarError } from "../manejo_errores";
import Swal from "sweetalert2";
import { BotonPrincipal } from "../componentes/btnPrincipal";

import withReactContent from "sweetalert2-react-content";
import { HeadersAuth, traerDatosObjeto } from "../funciones_utiles";
import { ModalPermisos } from "../componentes/modalPermisos";
import { ModalDesasignar } from "../componentes/modalDesasignar";

export const GestionAsociaciones = ({ sesion, setAlerta }) => {
	const manejarAlertas = (tipo, mensaje) => {
		// Usar setAlerta para mostrar la alerta
		setAlerta({ message: mensaje, type: tipo });
	};
	// Estados del Componente
	const MySwal = withReactContent(Swal);
	const [tempDatosFormulario, setTempDatosFormulario] = useState({}); // Almacena temporalmente los datos del formulario
	const [fetchDatos, setFetchDatos] = useState([]); // Guarda los datos de las asociaciones obtenidos del backend
	const [refresh, setRefresh] = useState(""); // Se utiliza para forzar la actualización de la lista de asociaciones
	const [idUnico, setIdUnico] = useState(); // ID de la asociación seleccionada para edición
	const [mostrarBotonLimpiar, setMostrarBotonLimpiar] = useState(false);
	const [mostrarFormulario, setMostrarFormulario] = useState(false);
	const [previewImage, setPreviewImage] = useState("");
	const [previewImageFondo, setPreviewImageFondo] = useState("");
	const [modoRedes, setModoRedes] = useState(false);
	const [idAdmin, setIdAdmin] = useState(null);
	const [imagenesSeleccionadas, setImagenesSeleccionadas] = useState([]);

	// Estado para almacenar los administradores disponibles y asignados
	const [adminsDisponibles, setAdminsDisponibles] = useState([]); // Lista de administradores disponibles
	const [adminsAsignados, setAdminsAsignados] = useState([]); // Lista de administradores asignados
	const [abrirModal, setAbrirModal] = useState(false);
	const [abrirModalDes, setAbrirModalDes] = useState(false);

	// Carga de datos iniciales
	useEffect(() => {
		if (idUnico) {
			(async () => {
				const URI_ASOCIACION = `${process.env.REACT_APP_DOMINIO}/asociacion/${idUnico}`;
				// console.log("Solicitando datos desde:", URI_ASOCIACION);
				const datosAsociacion = await traerDatosObjeto(URI_ASOCIACION);
				// console.log("Datos recibidos:", datosAsociacion);
				if (datosAsociacion) {
					setTempDatosFormulario({
						nombre: datosAsociacion.nombre,
						siglas: datosAsociacion.siglas,
						email: datosAsociacion.email,
						imagen: "",
						instagram: datosAsociacion.instagram,
						facebook: datosAsociacion.facebook,
						permisos: [],
						imagenesFondo: datosAsociacion.imagenesFondo?.map(ima => ({
							imagen: `${process.env.REACT_APP_DOMINIO_ARCHIVOS}/${idUnico}/IMAGENES/ASOCIACIONES/FONDOS/${ima.imagen}`
						})) || []
					} || {})
					setMostrarBotonLimpiar(true);
				} else {
					console.error("No se recibieron datos de la asociación.");
					manejarAlertas("error", "No se recibieron datos de la asociación.")
				}
			})();
		} else {
			// Estado inicial cuando no hay ID seleccionado
			setPreviewImage("");
			setTempDatosFormulario({
				nombre: "",
				siglas: "",
				email: "",
				imagen: "",
				instagram: "",
				facebook: "",
				permisos: [],
				imagenesFondo: []			
			});
			setMostrarBotonLimpiar(false);
		}
	}, [idUnico]);

	// Guardar asociación
	const guardarAsociacion = async (e) => {
		e.preventDefault();
		try {
			let url = idUnico
				? `${process.env.REACT_APP_DOMINIO}/asociacion/${idUnico}` // Para actualización
				: `${process.env.REACT_APP_DOMINIO}/asociacion`; // Para creación

			// console.log("URL:", url); // Depura la URL
			// console.log("Datos enviados:", tempDatosFormulario); // Depura los datos enviados

			let response;

			if (idUnico) {
				response = await axios.put(url, tempDatosFormulario, HeadersAuth); // Actualización
			} else {
				response = await axios.post(url, tempDatosFormulario, HeadersAuth); // Creación
			}

			// console.log("lo que se envía:", tempDatosFormulario.imagenesFondo)

			if (response.status === 200) {
				MySwal.fire({
					text: "Guardado Exitoso",
					icon: "success",
					confirmButtonText: "Ok",
				}).then(() => {
					setTempDatosFormulario({
						nombre: "",
						siglas: "",
						email: "",
						imagen: "",
						instagram: "",
						facebook: "",
						permisos: [],
						imagenesFondo: []
					});
					setPreviewImage("");
					setPreviewImageFondo("");
					setMostrarFormulario(false); // Oculta el primer formulario
					setMostrarBotonLimpiar(false); // Oculta el botón "+"
					setIdUnico(null);
					setRefresh(Date.now());
				});
			}
		} catch (error) {
			manejarAlertas("error", manejarError(error))

		}
	};

	// Obtiene la lista de asociaciones
	useEffect(() => {
		const fetchData = async () => {
			await fetchAsociaciones();
		};

		fetchData();
	}, [refresh]);

	const fetchAsociaciones = async () => {
		try {
			const response = await axios.get(
				`${process.env.REACT_APP_DOMINIO}/asociacion`,
				HeadersAuth
			);
			if (response.status === 200 && Array.isArray(response.data)) {
				// console.log("Asociaciones obtenidas:", response.data);
				setFetchDatos(response.data);
			} else {
				manejarAlertas("error", "No se encontraron asociaciones.")

				console.error("No se encontraron asociaciones.");
			}
		} catch (error) {
			console.error("Error al obtener asociaciones:", error);
			manejarAlertas("error", "Error al obtener asociaciones.")

		}
	};

	// Función para obtener administradores disponibles

	const handleImageChange = (e) => {
		const file = e.target.files && e.target.files[0];

		if (file) {
			// Validar que el archivo sea una imagen
			if (!file.type.startsWith("image/")) {
				console.warn("El archivo seleccionado no es una imagen válida.");

				manejarAlertas("error", "Solo se permiten archivos de imagen (JPG, JPEG, PNG).")

				return;
			}

			// Convertir el archivo a Base64
			const reader = new FileReader();
			reader.onloadend = () => {
				const base64String = reader.result; // Resultado en Base64
				// console.log("Archivo convertido a Base64:", base64String);

				// Actualiza el estado del formulario con el Base64
				setTempDatosFormulario((prev) => ({
					...prev,
					imagen: base64String, // Guarda la imagen en Base64
				}));

				// Genera una vista previa de la imagen
				setPreviewImage(base64String);
			};
			reader.readAsDataURL(file); // Convierte el archivo a Base64
		} else {
			console.warn("No se seleccionó ningún archivo válido.");
			manejarAlertas("error", "No se seleccionó ningún archivo válido.")

		}
	};
	// Carga los datos de una asociación para edición
	const handleEdit = async (id) => {
		// console.log("ID recibido:", id); // Depura el ID
		if (!id) {
			console.error("Error: idUnico es undefined");
			manejarAlertas("error", "No se pudo procesar la solicitud.")

			return;
		}
		try {
			const URI_ASOCIACION = `${process.env.REACT_APP_DOMINIO}/asociacion/${id}`;
			const datosAsociacion = await traerDatosObjeto(URI_ASOCIACION);
			// console.log("Datos de la asociación obtenidos:", datosAsociacion);
			setTempDatosFormulario({
				nombre: datosAsociacion.nombre,
				siglas: datosAsociacion.siglas,
				email: datosAsociacion.email,
				imagen: "",
				instagram: datosAsociacion.instagram,
				facebook: datosAsociacion.facebook,
				permisos: [],
				imagenesFondo: datosAsociacion.imagenesFondo || [] 
			} || {});
			if (datosAsociacion.imagen) {
				setPreviewImage(
					`${process.env.REACT_APP_DOMINIO_ARCHIVOS}/${id}/IMAGENES/ASOCIACIONES/${datosAsociacion.imagen}`
				);
			} else {
				setPreviewImage(``);
			}
			if (datosAsociacion.imagenesFondo && datosAsociacion.imagenesFondo.length > 0) {
				const imagenes = datosAsociacion.imagenesFondo.map(ima => ({
					imagen: `${process.env.REACT_APP_DOMINIO_ARCHIVOS}/${id}/IMAGENES/ASOCIACIONES/FONDOS/${ima.imagen}`
				}));
				setPreviewImageFondo(imagenes);
				// console.log("ima", imagenes)
				} else {
				setPreviewImageFondo([]);
			}
			setIdUnico(id);
			setMostrarFormulario(true);
		} catch (error) {

			console.error("Error al obtener los datos de la asociación:", error);
			manejarAlertas("error", "Error al obtener los datos de la asociación.")

		}
	};
	 
	// Función para mostrar el formulario y ocultar el botón
	const mostrarFormularioHandler = () => {
		setMostrarFormulario(true);
	};

	// Elimina una asociación
	const handleEliminarAsociacion = (id) => {
		MySwal.fire({
			title: "¿Estás seguro?",
			text: "Esta acción no se puede deshacer.",
			icon: "warning",
			showCancelButton: true,
			confirmButtonText: "Sí, eliminar",
			cancelButtonText: "Cancelar",
		}).then(async (result) => {
			if (result.isConfirmed) {
				try {
					const response = await axios.delete(
						`${process.env.REACT_APP_DOMINIO}/asociacion/${id}`,
						HeadersAuth
					);
					if (response.status === 200) {

						manejarAlertas("success", "La asociación ha sido eliminada.")

						setRefresh(Date.now()); // Actualiza la tabla
					}
				} catch (error) {
					manejarAlertas("error", manejarError(error))

				}
			}
		});
	};

	const convertirArchivoABase64 = (archivo) => {
		return new Promise((resolve, reject) => {
		const reader = new FileReader();
		reader.readAsDataURL(archivo);
		reader.onload = () => resolve(reader.result);
		reader.onerror = (error) => reject(error);
		});
	};

	const handleArchivoChange = async (e) => {
		const archivos = Array.from(e.target.files);
		const imagenesBase64 = await Promise.all(
			archivos.map((archivo) => convertirArchivoABase64(archivo))
		);

		setPreviewImageFondo((prev) => [
			...prev,
			...imagenesBase64.map((base64) => ({ imagen: base64 })),
		]);

		setImagenesSeleccionadas((prev) => [...prev, ...archivos]);
		setTempDatosFormulario((prev) => ({
			...prev,
			imagenesFondo: [...(prev.imagenesFondo || []), ...imagenesBase64],
		}));
		
	};

	const eliminarImagen = (index) => {
		const nuevasPreview = previewImageFondo.filter((_, i) => i !== index);
		const nuevasSeleccionadas = imagenesSeleccionadas.filter((_, i) => i !== index);

		setPreviewImageFondo(nuevasPreview);
		setImagenesSeleccionadas(nuevasSeleccionadas);

		setTempDatosFormulario((prev) => ({
		...prev,
		imagenesFondo: nuevasPreview,
		}));
	};

	// Manejo de cambios en el formulario
	const handleChange = (e) => {
		const { id, value } = e.target;
		setTempDatosFormulario((prev) => ({
			...prev,
			[id]: value,
		}));
	};

	const limpiarCampos = () => {
		setTempDatosFormulario({
			nombre: "",
			siglas: "",
			email: "",
			permisos: [],
			imagenesFondo: []
		});
		setIdUnico(null); // Limpiar el ID de la asociación seleccionada
		setPreviewImage("");
		setPreviewImageFondo("");
		setMostrarBotonLimpiar(false); // Ocultar el botón "+"
	};

	const editarEstadoAsoc = async (id_asociacion, estado) => {
		try {
			const response = await axios.put(`${process.env.REACT_APP_DOMINIO}/sesion/asociacion-activa`,
				{
					id_asociacion,
					activo: estado,
				},
				HeadersAuth
			);

			if (response.status == 200) {
				fetchAsociaciones();
			}

		} catch (error) {
			console.error("Error al cambiar el estado de la asociación:", error);
			manejarAlertas("error", "Error al cambiar el estado de la asociación.")
		}
	}

	const editarEstadoApp = async (id_asociacion, estadoApp) => {
		try {
			const response = await axios.put(`${process.env.REACT_APP_DOMINIO}/sesion/asociacion-activa`,
				{
					id_asociacion,
					activoApp: estadoApp
				},
				HeadersAuth
			);

			if (response.status == 200) {
				fetchAsociaciones();
			}

		} catch (error) {
			console.error("Error al cambiar el estado de la asociación en la app:", error);
			manejarAlertas("error", "Error al cambiar el estado de la asociación en la app.")
		}
	}

	/* Configuración de la tabla */
	const elScroll = { x: 0 };
	const columns = [
		{
			title: "NOMBRE",
			key: "nombre",
			align: "center",
			sorter: (a, b) => a.nombre.localeCompare(b.nombre),
			render: (a) => <span>{a.nombre}</span>,
		},
		{
			title: "SIGLAS",
			key: "siglas",
			align: "center",
			sorter: (a, b) => a.siglas.localeCompare(b.siglas),
			render: (a) => <span>{a.siglas}</span>,
		},
		{
			title: "ESTADO",
			key: "estado",
			align: "center",
			render: (_, record) => 
				<Switch
					checked={record.activo}
					onChange={() =>
						editarEstadoAsoc(
						record.id,
						!record.activo
						)
					}
					checkedChildren="ACTIVO"
          			unCheckedChildren="NO ACTIVO"
					style={{
						backgroundColor: record.activo
						? "#223463" 
						: "#BA1721", 
					}}
				/>
		},
		{
			title: "ESTADO APP",
			key: "estadoApp",
			align: "center",
			render: (_, record) => 
				<Switch
					checked={record.activoApp}
					onChange={() =>
						editarEstadoApp(
						record.id,
						!record.activoApp
						)
					}
					checkedChildren="ACTIVO"
          			unCheckedChildren="NO ACTIVO"
					style={{
						backgroundColor: record.activoApp
						? "#223463" 
						: "#BA1721", 
					}}
				/>
		},
		{
			title: "OPCIONES",
			key: "opciones",
			align: "center",
			render: (_, record) => (
				<div style={{ display: "flex", gap: "10px" }}>
					{/* Botón de Editar */}
					<FaRegEdit
						style={{ cursor: "pointer", color: "blue" }}
						onClick={() => handleEdit(record.id)}
					/>
					{/* Botón de Eliminar */}
					<FaRegTrashAlt
						style={{ cursor: "pointer", color: "red" }}
						onClick={() => handleEliminarAsociacion(record.id)}
					/>
					{/* Botón para Gestionar Administradores */}
					<FaUserPlus
						title="Asignar"
						style={{ cursor: "pointer", color: "green" }}
						onClick={() => [setAbrirModal(true), setIdAdmin(record.id)]}
					/>
					<FaUserMinus
						title="Desasignar"
						style={{ cursor: "pointer", color: "rgb(34, 52, 99)" }}
						onClick={() => [setAbrirModalDes(true), setIdAdmin(record.id)]}
					/>
				</div>
			),
		},
	];

	return (
		<div>
			<section
				id="seccionPiloto"
				style={{
					display: "flex",
					flexDirection: "column",
					justifyContent: "center",
					alignItems: "center",
					marginTop: "1em",
				}}>
				<h1 className="titulos">Gestión de Asociaciones</h1>
			</section>
			{/* Formulario de Creación/Edición */}
			<section
				style={{
					display: "flex",
					flexDirection: "column",
					justifyContent: "center",
					margin: "1em 0",
				}}>
				<div
					style={{
						width: "100%",
						maxWidth: "1200px",
						padding: "20px",
						margin: "0 auto",
					}}>
					<Row
						justify="space-between"
						align="middle"
						style={{ marginBottom: "1em" }}>
						<Col>
							{idUnico ? (
								<h2 className="titulos-secundarios">Editar Asociación</h2>
							) : (
								<h2 className="titulos-secundarios">Crear Asociación</h2>
							)}
						</Col>{" "}
						{mostrarBotonLimpiar && (
							<Button danger onClick={limpiarCampos} className="boton-azul">
								Nueva asociación
							</Button>
						)}
					</Row>
					<hr></hr>
					{mostrarFormulario && (
						<Form layout="vertical">
							<Row gutter={16} wrap={true}>
								{/* Nombre */}
								<Col xs={24} sm={8}>
									<InputCustom
									tipo="text"
									nombreCampo="Nombre"
									idCampo="nombre"
									elPlaceholder="Ingrese el nombre de la asociación"
									elValue={tempDatosFormulario.nombre || ""}
									onChange={handleChange}
									required={true}
									/>
								</Col>

								{/* Siglas */}
								<Col xs={24} sm={8}>
									<InputCustom
									tipo="text"
									nombreCampo="Siglas"
									idCampo="siglas"
									elPlaceholder="Ingrese las siglas de la asociación"
									elValue={tempDatosFormulario.siglas || ""}
									onChange={handleChange}
									required={true}
									/>
								</Col>

								{/* Email */}
								<Col xs={24} sm={8}>
									<InputCustom
									tipo="text"
									nombreCampo="Email"
									idCampo="email"
									elPlaceholder="Ingrese el email de la asociación"
									elValue={tempDatosFormulario.email || ""}
									onChange={handleChange}
									required={true}
									/>
								</Col>
								<Col xs={24} sm={4} style={{ display: "flex", flexDirection: "column", gap: 16 }}>
									<InputCustom
										tipo="text"
										nombreCampo="Instagram"
										idCampo="instagram"
										elPlaceholder="Pegá la url de Instagram"
										elValue={tempDatosFormulario.instagram || ""}
										onChange={handleChange}
										required={false}
										style={{ width: "100%" }} // Asegura que el input ocupe todo
									/>
								</Col>

								<Col xs={24} sm={4}>
									<InputCustom
									tipo="text"
									nombreCampo="Facebook"
									idCampo="facebook"
									elPlaceholder="Pegá la url de Facebook"
									elValue={tempDatosFormulario.facebook || ""}
									onChange={handleChange}
									required={false}
									/>
								</Col>
								<Col xs={24} sm={8}
									style={{ width: "100%" }}
								>
									<Form.Item
										style={{
										width: "100%",
										}}>
										<div
											style={{
												width: "100%",
											}}>
											{/* Botón personalizado */}
											<div style={{ position: "relative", display: "inline-block", width: "100%" }}>
												<label
												htmlFor="image-upload-fondo"
												style={{
													display: "flex",
													height: 30,
													width: "100%",
													alignItems: "center",
													justifyContent: "center",
													backgroundColor: "#223463",
													color: "#fff",
													borderRadius: "5px",
													cursor: "pointer",
													fontSize: "16px",
													border: "none",
													outline: "none",
													transition: "background-color 0.3s ease",
													marginTop: "1.3em",
													padding: "0 10px",
												}}>
												<span style={{ marginRight: "10px" }}>↑</span>
												<span
													style={{
													height: "30px",
													width: "0.5px",
													backgroundColor: "#fff",
													margin: "0 10px",
													}}></span>
												Subir imágenes
												</label>
												<input
													id="image-upload-fondo"
													type="file"
													multiple
													accept="image/png, image/jpeg, image/jpg"
													onChange={handleArchivoChange}
													style={{ display: "none" }}
												/>
											</div>
										</div>
									</Form.Item>
								</Col>
								<Col
									xs={24} sm={8}
									style={{ display: "flex", justifyContent: "center", width: "100%" }}
								>
									<Form.Item style={{ width: "100%" }}>
									<div
										className="contenedorLogo"
										style={{
										display: "flex",
										flexDirection: "row",
										alignItems: "center",
										gap: "1em",
										width: "100%"
										}}
									>
										<div style={{ position: "relative", display: "inline-block", width: "100%", alignSelf: "baseline" }}>
											<label
												htmlFor="image-upload"
												style={{
												display: "flex",
												alignItems: "center",
												justifyContent: "center",
												height: "2em",
												width: "100%",
												backgroundColor: "#223463",
												color: "#fff",
												borderRadius: "5px",
												cursor: "pointer",
												fontSize: "16px",
												border: "none",
												outline: "none",
												transition: "background-color 0.3s ease",
												marginTop: "1.3em",
												}}
											>
												<div style={{ display: "flex", width: "100%", justifyContent: "center", alignItems: "center", padding: "0 10px" }}>
													<span style={{ marginRight: "10px" }}>↑</span>
													<span
													style={{
														height: "30px",
														width: "0.5px",
														backgroundColor: "#fff",
														margin: "0 10px",
													}}
													></span>
													Subir logo
												</div>
											</label>
											<input
												id="image-upload"
												type="file"
												accept=".jpg,.jpeg,.png"
												onChange={handleImageChange}
												style={{ display: "none" }}
											/>
										</div>
									</div>
									</Form.Item>
								</Col>
							</Row>
							<Row gutter={16}>
								<Col xs={24} sm={16}>
									{previewImageFondo && previewImageFondo.length > 0 && (
										<div
										style={{
											width: "100%",
											background: "#f5f5f5",
											padding: "1em",
											borderRadius: "8px",
											border: "1px solid #d9d9d9",
										}}>
										<p style={{ fontWeight: "bold", marginBottom: "0.5em" }}>
											Imágenes cargadas: {previewImageFondo.length}
										</p>
					
										<div
											style={{
											display: "grid",
											gridTemplateColumns: "repeat(auto-fill, minmax(100px, 1fr))",
											gap: "10px",
											}}>
											{previewImageFondo.map((img, index) => (
											<div
												key={index}
												style={{
												position: "relative",
												width: "100%",
												height: "100px",
												borderRadius: "8px",
												overflow: "hidden",
												border: "1px solid #ddd",
												}}>
												<img
												src={img.imagen}
												alt={`Vista previa ${index}`}
												style={{
													width: "100%",
													height: "100%",
													objectFit: "cover",
												}}
												/>
												<button
												onClick={() => eliminarImagen(index)}
												style={{
													position: "absolute",
													top: "4px",
													right: "4px",
													backgroundColor: "rgba(0,0,0,0.6)",
													border: "none",
													color: "#fff",
													borderRadius: "50%",
													width: "20px",
													height: "20px",
													fontSize: "14px",
													lineHeight: "20px",
													textAlign: "center",
													cursor: "pointer",
												}}
												title="Eliminar imagen">
												×
												</button>
											</div>
											))}
										</div>
										</div>
									)}
								</Col>
								<Col xs={24} sm={8}	
									style={{ display: "flex", alignItems: "center", justifyContent: "center" }}
								>
									{/* Vista previa */}
									{previewImage && (
										<div
											style={{
											position: "relative",
											display: "flex",
											flexDirection: "column",
											justifyContent: "center",
											alignItems: "center",
											width: "100%",
											height: "160px",
											borderRadius: "8px",
											overflow: "hidden",
											border: "1px solid #ddd",
											}}
										>
											<p style={{ fontWeight: "bold", marginBottom: "0.5em" }}>
												Logo cargado:
											</p>
											<img
											src={previewImage}
											alt="Vista previa"
											style={{
												width: "100px",
												height: "100px",
												objectFit: "cover",
												borderRadius: "8px", // Añade bordes redondeados para un diseño más moderno
												border: "1px solid #ddd", // Agrega un borde sutil para destacar la imagen
												}}
											/>
										</div>
									)}
								</Col>
							</Row>
							<Row>
								
							</Row>
							<Row gutter={16}>
								<Col xs={24} sm={16}>
									<Button
										type="primary"
										className="boton-principal"
										onClick={guardarAsociacion}
										style={{ marginTop: 20 }}
									>
										{idUnico ? "Actualizar" : "Guardar"}
									</Button>
								</Col>
							</Row>
						</Form>
					)}
				</div>
			</section>
			<ModalPermisos
				open={abrirModal}
				onClose={() => setAbrirModal(false)}
				id_asociacion={idAdmin}
				setAlerta={setAlerta}
			/>
			<ModalDesasignar 
				open={abrirModalDes}
				onClose={() => setAbrirModalDes(false)}
				id_asociacion={idAdmin}
				manejarAlertas={manejarAlertas}
			/>
			{/* Tabla de resultados */}
			<div
				className="botonDescargar"
				style={{
					display: "flex",
					flexDirection: "column",
					flexWrap: "wrap",
					alignContent: "center",
					justifyContent: "center",
					alignItems: "flex-end",
				}}
			>
				<TablaCompleta
					tituloPDF={"asociaciones"}
					elScroll={elScroll}
					columns={columns}
					fetchDatos={fetchDatos.length > 0 ? fetchDatos : []}
					rowKey={"id"}
					mostrarBoton={false}
					gestionTabla={
						<Row style={{ gap: "10px" }}>
							{!mostrarFormulario && (
								<BotonPrincipal
									texto="Agregar asociación"
									onClick={mostrarFormularioHandler}
								/>
							)}
						</Row>
					}
				/>
			</div>
		</div>
	);
};
